<template>
  <div
    class="w-full bg-gray-800/5 rounded-[10px] p-3 tablet-h:px-[25px] tablet-h:py-[23px]"
  >
    <div
      v-for="(price, index) in prices"
      :key="`price-${index}`"
      class="mb-1.5 w-full flex items-center justify-between text-[14px] leading-[22px] text-gray-800"
    >
      <div class="mr-3">{{ t(price.description) }}</div>
      <div class="text-right">
        <template v-if="price.details.amount">
          {{ formatPriceDetails(price.details) }}
        </template>
        {{ t(price.details.suffix) }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type {
  BillingPrice,
  BillingPriceDetail,
} from '@/shared/graphql/legacy/generated'
import { t } from '@/shared/i18n'
import { formatPrice } from '@/shared/utils/money'

defineProps<{
  prices: BillingPrice[]
}>()

const formatPriceDetails = (price: BillingPriceDetail) => {
  return formatPrice({
    amount: (price.amount || 0) / 100,
    currency: price.currency,
  })
}
</script>
